<template>
    <div class="vue-selected-vehicle section-spacing-margin">
        <div class="row">
            <div class="col-lg-4 order-lg-0">
                <h2 class="virtual-h3 color-text mb-0">{{ item.title }}</h2>
                <p v-if="item.short_description" class="short-description virtual-h2 my-1">{{ item.short_description }}</p>
                <p class="color-text text-italic mb-2 mb-lg-4">{{ item.subtitle }}</p>

                <Badges
                    v-if="showBadges"
                    :badges="[
                        ...item.fuel_types,
                        ...item.transmission_types,
                        ...item.body_work_types,
                    ]"
                />

                <aut-vehicle-details :item="item" class="d-lg-none"></aut-vehicle-details>

                <table class="price-wrapper">
                    <tr>
                        <th v-if="item.price_per_day && !item.show_week_prices">{{ translations.day }}</th>
                        <th v-if="item.price_per_weekend && !item.show_week_prices">{{ translations.weekend }}</th>
                        <th v-if="item.price_per_week">{{ translations.week }}</th>
                        <th v-if="item.price_per_2_weeks && item.show_week_prices">2 weken</th>
                        <th v-if="item.price_per_3_weeks && item.show_week_prices">3 weken</th>
                    </tr>
                    <tr>
                        <td v-if="item.price_per_day && !item.show_week_prices" v-html="generatePriceMarkup(prices.per_day)"></td>
                        <td v-if="item.price_per_weekend && !item.show_week_prices" v-html="generatePriceMarkup(prices.per_weekend)"></td>
                        <td v-if="item.price_per_week" v-html="generatePriceMarkup(prices.per_week)"></td>
                        <td v-if="item.price_per_2_weeks && item.show_week_prices" v-html="generatePriceMarkup(prices.per_2_weeks)"></td>
                        <td v-if="item.price_per_3_weeks && item.show_week_prices" v-html="generatePriceMarkup(prices.per_3_weeks)"></td>
                    </tr>
                </table>

                <div class="d-flex">
                    <button @click.stop="handleClickRentVehicle" class="btn-primary m-0 w-100">{{ translations.rentDirectly }}</button>
                    <button @click="handleModal" class="information-button btn-white">{{ translations.moreInformation }}</button>
                </div>
            </div>

            <div class="col-lg-5 d-flex flex-column justify-content-center order-first order-lg-1">
                <div class="image" v-if="hasImage">
                    <img
                        v-if="hasImage"
                        :src="item.images[0]" :alt="item.title">
                </div>
            </div>

            <div class="col-lg-3 order-lg-2">
                <aut-vehicle-details :item="item" class="d-none d-lg-block"></aut-vehicle-details>

                <aut-youtube-iframe
                    v-if="item.video"
                    :url="item.video"
                    class="d-none d-xl-block"
                ></aut-youtube-iframe>
            </div>
        </div>
    </div>
</template>

<script>
import analytics from "../../mixins/analytics";
import vehicle from "../../mixins/vehicle";
import currencyFormatter from "../../mixins/CurrencyFormatter";
import translations from "../../mixins/translations";
import Details from "./Details.vue";
import YoutubeIframe from "../YoutubeIframe.vue";
import Badges from "./Badges.vue";
import {isEmpty} from "lodash";

export default {
    name: "SelectedVehicle",

    mixins: [currencyFormatter, analytics, vehicle, translations],

    components: {
        Badges,
        'aut-vehicle-details': Details,
        'aut-youtube-iframe': YoutubeIframe
    },

    props: {
        id: {
            type: String|Number,
        },
        item: {
            type: Object,
            required: true,
        },
        isBusiness: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        prices() {
            const vat = drupalSettings.vat_percentage;

            return {
                per_day: this.calculatePrice(this.item.price_per_day, vat),
                per_weekend: this.calculatePrice(this.item.price_per_weekend, vat),
                per_week: this.calculatePrice(this.item.price_per_week, vat),
                per_2_weeks: this.calculatePrice(this.item.price_per_2_weeks, vat),
                per_3_weeks: this.calculatePrice(this.item.price_per_3_weeks, vat),
                discount_price: this.calculatePrice(this.item.discount_price, vat),
            };
        },

        showBadges() {
            return !isEmpty(this.item.fuel_types) || !isEmpty(this.item.transmission_types) || !isEmpty(this.item.body_work_types);
        }
    },

    methods: {
        calculatePrice(price, vatPercentage) {
            return (this.isBusiness === true) ? (price / (1 + (vatPercentage / 100))).toFixed(2) : price;
        },

        generatePriceMarkup(price) {
            if (isNaN(price) || price === null || price === undefined) {
                return price;
            }
            else if (Number.isInteger(price)) {
                return price + ",-";
            }

            const priceParts = price.toString().split(".");
            return `${priceParts[0]},<sup>${priceParts[1]}</sup>`;
        }
    }
}
</script>
